import React, { Component } from "react";
import { Select, DatePicker, Table, Modal, Drawer } from "antd";
import moment from "moment-timezone";
import Header from "../../../Common/Component/Header";
import Sidebar from "../../../Common/Component/Sidebar";
import DataTable from "./Datatable";
import Loader from '../../../Common/Component/Loader';
import Reschedule from "./RescheduleDrawer";
import {errorHandle} from "../../../Common/errorHandle";


const { Option } = Select;

class EODReports extends Component {
  state = {
    loader: false,
    current_tab: 0,
    selectedRowKeys: [],
    is_submit_eod: false,
    is_reschedule_all: false,
    is_reschedule_drawer: false,
    report: [],
    reportDate: moment().format('YYYY-MM-DD'),
    active_pagination: '15',
    report_pagination: { current: 1, showSizeChanger: false, pageSize: 15, ordering: "", },
    filters: {},
    service_data: {}
  };

  componentDidMount() {
    const accessToken = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser")).key
      : "";

    if (accessToken) {
      this.props.getServiceEODReport({
        limit: 15,
        offset: 0,
        schedule_strart_ts__date: moment().format('YYYY-MM-DD'),
        is_completed: true
      });
      this.setState({
        loader: true,
        filters: {
          limit: 15,
          offset: 0,
          schedule_strart_ts__date: moment().format('YYYY-MM-DD'),
          is_completed: true
        }
      });
    } else {
      window.location.assign("/");
      localStorage.clear();
      sessionStorage.clear();
    }
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    if (Object.keys(props.ServiceEODReport.report).length > 0 && props.ServiceEODReport.report !== this.props.ServiceEODReport.report) {
      this.setState({
        report_pagination: { 
          ...this.state.report_pagination,
          total: props.ServiceEODReport.report.count},
        loader: false,
        report: props.ServiceEODReport.report.results
      })
    }

    if (Object.keys(props.ServiceEODReport.data).length > 0 && props.ServiceEODReport.data !== this.props.ServiceEODReport.data) {
      this.setState({
        loader: false
      })
    }
    
    
    if (Object.keys(props.ServiceEODReport.errors).length > 0 && props.ServiceEODReport.errors !== this.props.ServiceEODReport.errors) {
      errorHandle(props.ServiceEODReport.errors)
      this.setState({
        loader: false,
      })
    }
  };

    //set page limit
    setPageLimit = (custom_limit) => {
      let { report_pagination, current_tab, reportDate } = this.state;
      report_pagination = Object.assign(report_pagination, { 'current': 1, 'pageSize': custom_limit });

      this.setState({
        report_pagination,
        active_pagination: custom_limit,
        loader: true,
        report: []
      })
      let data = {}
      if( current_tab === 0 ){
        data = {
          offset: 0, limit: custom_limit, is_completed: true, schedule_strart_ts__date: reportDate
        }
      } else if( current_tab === 1) {
        data = {
          offset: 0, limit: custom_limit, is_cancelled: true, schedule_strart_ts__date: reportDate
        }
      } else if( current_tab === 2) {
        data = {
          offset: 0, limit: custom_limit, is_completed: false, is_cancelled: false, schedule_strart_ts__date: reportDate,
          is_rescheduled: false
        }
      }
      this.setState({
        filters: data
      })
      Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
      this.props.getServiceEODReport(data);
    }
  
  
    //Table Pagination and Ordering
    onReportHandleChange = (pagination, filters, sorter) => {
      let { report_pagination, active_pagination, search_value, current_tab, reportDate } = this.state;
  
      report_pagination = Object.assign(report_pagination, { 'current': pagination.current });
  
      let ordering = ''
      if (sorter.column) {
        ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`
      }
      else {
        ordering = ''
      }

      let data = {}
  
      if( current_tab === 0 ) {
        data = {
          offset: (pagination.current * 15) - 15,
          limit: active_pagination,
          ordering,
          search: search_value,
          is_completed: true,
          schedule_strart_ts__date: reportDate
        }
      } else if( current_tab === 1 ) {
        data = {
          offset: (pagination.current * 15) - 15,
          limit: active_pagination,
          ordering,
          search: search_value,
          is_cancelled: true,
          schedule_strart_ts__date: reportDate
        }
      } else if( current_tab === 2 ) {
        data = {
          offset: (pagination.current * 15) - 15,
          limit: active_pagination,
          ordering,
          search: search_value,
          is_completed: false,
          is_cancelled: false,
          schedule_strart_ts__date: reportDate,
          is_rescheduled:false
        }
      }

      Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
      this.setState({
        report_pagination,
        loader: true,
        filters: data
      })

      this.props.getServiceEODReport(data)
    }

  //Selct Table Row checkbox
  onSelectedRowKeysChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  onRescheduleAll = () => {
    const { selectedRowKeys, filters } = this.state
    let params = []
    for(let i = 0; i < selectedRowKeys.length; i++ ){
      params.push({
        "uuid": selectedRowKeys[i],
        "is_rescheduled": true,
        "rescheduled_notes": "rechedule"
      })
    }
    this.setState({
      loader: true,
      report: []
    })
    this.props.rescheduleMultipleServices( params )
    this.props.getServiceEODReport(filters)
  }

  //update Reschudle
  updateRescheduleData = (data) => {
    this.setState({
      service_data: data
    })
  }

  //Close Drawer
  closeRescheduleDrawer = (e) => {
    this.setState({
      is_reschedule_drawer: e,
    });
    this.props.getServiceEODReport(this.state.filters)
  };
  
  onServiceTypeChange = (e) => {
    let { filters } = this.state

    this.setState({
      filters: {
        ...filters,
        service__service_order__service_type: e
      }
    })
    this.props.getServiceEODReport({
      ...filters,
      service__service_order__service_type: e
    })
  }

  setDate = (e) => {
    const { current_tab, filters } = this.state
    this.setState({
      reportDate: moment(e).format('YYYY-MM-DD')
    })
    if(current_tab === 0) {
      this.props.getServiceEODReport({
        limit: 15,
        offset: 0,
        schedule_strart_ts__date: moment(e).format('YYYY-MM-DD'),
        is_completed: true
      });
      this.setState({
        filters: {
          limit: 15,
          offset: 0,
          schedule_strart_ts__date: moment(e).format('YYYY-MM-DD'),
          is_completed: true
        }
      })
    } else if( current_tab === 1 ) {
      this.props.getServiceEODReport({
        limit: 15,
        offset: 0,
        schedule_strart_ts__date: moment(e).format('YYYY-MM-DD'),
        is_cancelled: true,
        service__service_order__service_type: filters.service__service_order__service_type ? filters.service__service_order__service_type : ''
      });
      this.setState({
        filters: {
          limit: 15,
          offset: 0,
          schedule_strart_ts__date: moment(e).format('YYYY-MM-DD'),
          is_cancelled: true,
          service__service_order__service_type: filters.service__service_order__service_type ? filters.service__service_order__service_type : ''
        }
      })
    }  else if( current_tab === 2 ) {
      this.props.getServiceEODReport({
        limit: 15,
        offset: 0,
        schedule_strart_ts__date: moment(e).format('YYYY-MM-DD'),
        is_cancelled: false,
        is_completed: false,
        service__service_order__service_type: filters.service__service_order__service_type ? filters.service__service_order__service_type : '',
        is_rescheduled: false
      });
      this.setState({
        filters: {
          limit: 15,
          offset: 0,
          schedule_strart_ts__date: moment(e).format('YYYY-MM-DD'),
          is_cancelled: false,
          is_completed: false,
          service__service_order__service_type: filters.service__service_order__service_type ? filters.service__service_order__service_type : '',
          is_rescheduled: false
        }

      })
    } 
  }

  render() {
    let {
      loader,
      current_tab,
      selectedRowKeys,
      is_submit_eod,
      is_reschedule_all,
      is_reschedule_drawer,
      active_pagination, 
      report,
      filters,
      report_pagination
    } = this.state;
    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header placeholder="Search acc number, customer address or contact details" />

          {/* Sidebar */}
          <Sidebar history={this.props.history} />

          <div className="container">
            <div className="filter_wrapper">
              <div className="left_side">
                <div className="fitem mr-2">
                  <DatePicker
                    defaultValue={moment()}
                    format="(MMM DD,YYYY)"
                    className="dwhite field_date_picker"
                    onChange = {(e) => {this.setDate(e)} }
                    allowClear = {false}
                  />
                </div>
                <div className="fitem mr-2">
                  <Select
                    placeholder="All Services"
                    defaultValue=""
                    className="swhite"
                    onChange={(e) => {
                      this.onServiceTypeChange(e);
                    }}
                  >
                    <Option value="">All Services</Option>
                    <Option value="residential">Residential</Option>
                    <Option value="commercial">Commercial</Option>
                    {/* <Option value="pws_install">PWS Install</Option> */}

                  </Select>
                </div>
                <ul className="tabs">
                  <li
                    onClick={() => {
                      this.setState({ current_tab: 0, 
                        selectedRowKeys: [], 
                        report: [], 
                        loader: true,
                        filters:{                        
                          limit: 15,
                          offset: 0,
                          is_completed: true,
                          schedule_strart_ts__date: this.state.reportDate,
                          service__service_order__service_type: filters.service__service_order__service_type ? filters.service__service_order__service_type : ''

                        } 
                      })
                      this.props.getServiceEODReport({
                        limit: 15,
                        offset: 0,
                        is_completed: true,
                        schedule_strart_ts__date: this.state.reportDate,
                        service__service_order__service_type: filters.service__service_order__service_type ? filters.service__service_order__service_type : ''

                      });

                    }}
                    className={current_tab === 0 ? "active" : ""}
                  >
                    <span>COMPLETED</span>
                  </li>
                  <li
                    onClick={() => {
                      this.setState({ current_tab: 1, selectedRowKeys: [], loader: true, report: [], filters:{                        
                        limit: 15,
                        offset: 0,
                        is_cancelled: true,
                        schedule_strart_ts__date: this.state.reportDate,
                        service__service_order__service_type: filters.service__service_order__service_type ? filters.service__service_order__service_type : ''
                      } 
                      });
                      this.props.getServiceEODReport({
                        limit: 15,
                        offset: 0,
                        schedule_strart_ts__date: this.state.reportDate,
                        is_cancelled: true,
                        service__service_order__service_type: filters.service__service_order__service_type ? filters.service__service_order__service_type : ''

                      });
                    }}
                    className={current_tab === 1 ? "active" : ""}
                  >
                    <span>CANCELLED</span>
                  </li>
                  <li
                    onClick={() => {
                      this.setState({ current_tab: 2, selectedRowKeys: [], report:[], 
                        loader: true,
                        filters:{                        
                          limit: 15,
                          offset: 0,
                          is_cancelled: false,
                          is_completed: false,
                          schedule_strart_ts__date: this.state.reportDate,
                          service__service_order__service_type: filters.service__service_order__service_type ? filters.service__service_order__service_type : '',
                          is_rescheduled: false
                        } 
                      });
                      this.props.getServiceEODReport({
                        limit: 15,
                        offset: 0,
                        schedule_strart_ts__date: this.state.reportDate,
                        is_completed: false,
                        is_cancelled: false,
                        service__service_order__service_type: filters.service__service_order__service_type ? filters.service__service_order__service_type : '',
                        is_rescheduled: false

                      });

                    }}
                    className={current_tab === 2 ? "active" : ""}
                  >
                    <span>MISSED</span>
                  </li>
                </ul>
              </div>

              <div className="right_side">
                {this.state.report.length > 0 ?
                  <span className="ico-btn">
                    <i className="las la-download" onClick={() => {
                      let filename = this.state.current_tab === 0 ? "COMPLETED" : this.state.current_tab === 1 ? 'CANCELLED' : 'MISSED'
                      filename = filename + '-' + moment(filters.schedule_strart_ts__date).format('MMDDYYYY')

                      this.props.getServiceEODReport({
                        ...filters,
                        format:'csv'
                      }, filename)
                    }}></i>
                  </span>
                  :
                  ''
                }
                {/* <span className="ico-btn">
                  <i className="las la-download" onClick={() => {
                    this.props.getServiceEODReport({
                      ...filters,
                      format:'csv'
                    })
                  }}></i>
                </span> */}

                <button
                  hidden={current_tab === 0 || current_tab === 1 || this.state.report.length < 1}
                  className="btn btn-brand btn-bdr"
                  onClick={() => {
                    this.setState({ is_reschedule_all: true });
                  }}
                  disabled={
                    this.state.selectedRowKeys.length > 0 ? false : true
                  }
                >
                  Reschedule All
                </button>
                {/* <button
                  className="btn btn-warning"
                  onClick={() => {
                    this.setState({ is_submit_eod: true });
                  }}
                >
                  Submit EOD Report
                </button> */}
              </div>
            </div>

            <div className="table_wrapper">
              {current_tab === 0 ? (
                <React.Fragment>
                  <Table
                    rowKey={(record) => record.uuid}
                    dataSource={report}
                    columns={DataTable.CompletedReportList(this)}
                    pagination={report_pagination}
                    onChange={this.onReportHandleChange}
                    position={false}
                    showSorterTooltip={false}
                  />
                  <ul className="pagination_page_size">
                    <li>
                      <span>Show:</span>
                    </li>
                    <li>
                      <span
                        onClick={() => { this.setPageLimit('15') }}
                        className={active_pagination === '15' ? 'active' : ''}
                      >15</span>
                    </li>
                    <li>
                      <span
                        className={active_pagination === '30' ? 'active' : ''}
                        onClick={() => { this.setPageLimit('30') }}>30</span>
                    </li>
                    <li>
                      <span
                        className={active_pagination === '60' ? 'active' : ''}
                        onClick={() => { this.setPageLimit('60') }}>60</span>
                    </li>
                  </ul>
                </React.Fragment>
              ) : (
                ""
              )}

              {current_tab === 1 ? (
                <React.Fragment>
                  <Table
                    rowKey={(record) => record.uuid}
                    dataSource={report}
                    columns={DataTable.CancledReportList(this)}
                    pagination={report_pagination}
                    onChange={this.onReportHandleChange}
                    // rowSelection={{
                    //   type: "checkbox",
                    //   selectedRowKeys,
                    //   onChange: this.onSelectedRowKeysChange,
                    // }}
                    position={false}
                    showSorterTooltip={false}
                  />
                  <ul className="pagination_page_size">
                    <li>
                      <span>Show:</span>
                    </li>
                    <li>
                      <span
                        onClick={() => { this.setPageLimit('15') }}
                        className={active_pagination === '15' ? 'active' : ''}
                      >15</span>
                    </li>
                    <li>
                      <span
                        className={active_pagination === '30' ? 'active' : ''}
                        onClick={() => { this.setPageLimit('30') }}>30</span>
                    </li>
                    <li>
                      <span
                        className={active_pagination === '60' ? 'active' : ''}
                        onClick={() => { this.setPageLimit('60') }}>60</span>
                    </li>
                  </ul>
                </React.Fragment>
              ) : (
                ""
              )}
              {current_tab === 2 ? (
                <React.Fragment>
                  <Table
                    rowKey={(record) => record.uuid}
                    dataSource={report}
                    columns={DataTable.MissedReportList(this)}
                    pagination={report_pagination}
                    onChange={this.onReportHandleChange}
                    position={false}
                    rowSelection={{
                      type: "checkbox",
                      selectedRowKeys,
                      onChange: this.onSelectedRowKeysChange,
                    }}
                    showSorterTooltip={false}
                  />
                  <ul className="pagination_page_size">
                    <li>
                      <span>Show:</span>
                    </li>
                    <li>
                      <span
                        onClick={() => { this.setPageLimit('15') }}
                        className={active_pagination === '15' ? 'active' : ''}
                      >15</span>
                    </li>
                    <li>
                      <span
                        className={active_pagination === '30' ? 'active' : ''}
                        onClick={() => { this.setPageLimit('30') }}>30</span>
                    </li>
                    <li>
                      <span
                        className={active_pagination === '60' ? 'active' : ''}
                        onClick={() => { this.setPageLimit('60') }}>60</span>
                    </li>
                  </ul>
                </React.Fragment>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        {/* Reschedule Selected Service */}
        <Modal
          visible={is_reschedule_all}
          okText={"Reschedule Services"}
          cancelText={"Cancel"}
          onOk={() => { 
            this.onRescheduleAll()
            this.setState({ is_reschedule_all: false });
            this.props.getServiceEODReport(filters)
            
          }}
          onCancel={() => {
            this.setState({ is_reschedule_all: false });
          }}
          className="delete_user_modal"
          width={532}
          centered={true}
        >
          <div className="p15">
            <h4>
              Do you wish to reschedule all selected services to the next
              available day?
            </h4>
            <p>
              Any services that haven’t been manually rescheduled will be
              scheduled for the next available time/day as per their service
              requirements.
            </p>

            <div className="reschedule_box">
              <p>
                Due to a high demand of services for this week your service has
                been missed for the day of {`${moment(`${this.state.reportDate}`).format('MM/DD/YYYY')}`}, and we will be
                rescheduled to our next available slot the following week.
              </p>

              <p>
                If you cannot make this slot, please contact our Head Office to
                reschedule.
              </p>
            </div>
          </div>
        </Modal>

        {/* Submit EOD report */}
        <Modal
          visible={is_submit_eod}
          okText={"Submit EOD Report"}
          cancelText={"Cancel"}
          onOk={() => {
            this.setState({ is_submit_eod: false });
          }}
          onCancel={() => {
            this.setState({ is_submit_eod: false });
          }}
          className="delete_user_modal"
          width={532}
          centered={true}
        >
          <div className="p15">
            <h4>Ready to submit EOD Report?</h4>
            <p>
              Looks like all cancelled/missed services are now scheduled! You
              can now submit your EOD Report.
            </p>
          </div>
        </Modal>

        <Drawer
          visible={is_reschedule_drawer}
          width={"420"}
          closable={false}
          className="drawer-wrapper create_ticket_drawer"
        >
          <Reschedule
            data = {this.state.service_data}
            rescheduleMultipleServices = {this.props.rescheduleMultipleServices}
            closeRescheduleDrawer={() => {
              this.closeRescheduleDrawer();
            }}
          />
        </Drawer>
        {loader ? <Loader /> : ''}
      </div>

    );
  }
}

export default EODReports;
